import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-points-overview',
  templateUrl: './points-overview.component.html',
  styleUrls: ['./points-overview.component.scss']
})
export class PointsOverviewComponent implements OnInit {

  public actionPoints: number = 28;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/points-overview/points-overview.component.ts